import { createFileRoute } from "@tanstack/react-router";
import { userAdminQueries } from "../../../features/user-admin/api/user-admin.queries";
import { customersQueries } from "../../../shared/queries/customers.queries";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Change one user's roles and locations
 * @primary User form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/admin/users/$id")({
  loader: async ({ context, params }) => {
    const [user, customers] = await Promise.all([
      context.queryClient.ensureQueryData(userAdminQueries.detail(params.id)),
      context.queryClient.ensureQueryData(customersQueries.list()),
    ]);
    return { user, customers };
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
